import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from './pages/Home/Home';
import Leaderboard from './pages/Leaderboard/Leaderboard';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/leaderboard" element={<Leaderboard />} />

    </Routes>
  );
}

export default App;
